import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper } from '../Table/styled';
import SharedTable from 'shared/ui/Table';
import { useIntl } from 'react-intl';
import RunUserAgentModal from '../Grid/components/UserAgents/components/RunUserAgentModal';
import { MODAL_AGENT_DETAIL, MODAL_RUN_USER_AGENT } from 'store/modals/modals';
import selectModal from 'store/modals/selectors';
import EmptyAgents from '../Grid/components/EmptyAgents';
import NoSearchResults from 'Common/Components/NoSearchResults';
import { selectIsFetching } from 'store/Agents/selectors';
import { setAgentsEntity, setOrderByCloudAgents } from 'store/Agents/actions';
import { SECURITY_SCANNERS_ENTITY } from 'store/Agents/reducer';
import { selectIsFiltering } from 'store/Filters/selectors';
import cloudAgentsSchema from './schema';

const CloudAgentsTable = ({ agents }) => {
  const dispatch = useDispatch();
  const [agentsList, setAgentsList] = useState(agents);
  const isFetching = useSelector(selectIsFetching);
  const show = useSelector((state) => selectModal(state, MODAL_AGENT_DETAIL));
  const isFiltering = useSelector((state) => selectIsFiltering(SECURITY_SCANNERS_ENTITY, state));
  const intl = useIntl();

  const showRunUserAgent = useSelector((state) => selectModal(state, MODAL_RUN_USER_AGENT));

  useEffect(() => {
    setAgentsList(agents);
  }, [agents]);

  const fetchData = (sorted) => {
    if (!isFetching) {
      dispatch(setOrderByCloudAgents(sorted));
    }
  };

  let noDataText = '';
  if (!isFetching) noDataText = isFiltering ? <NoSearchResults /> : <EmptyAgents />;

  useEffect(() => {
    dispatch(setAgentsEntity(SECURITY_SCANNERS_ENTITY));
  }, [dispatch]);

  return (
      <Wrapper>
      {showRunUserAgent && <RunUserAgentModal /> }
      <SharedTable
        schema={ cloudAgentsSchema }
        context={ { isFetching, show, intl } }
        data={ agentsList }
        isLoading={ isFetching }
        onFetch={ fetchData }
        noDataText={ noDataText }
      />
      </Wrapper>
  );
};

export default CloudAgentsTable;
